export default __webpack_public_path__ + "static/media/lovrican-africa.2e9c310e.svg";